import arrayParser from "../arrayParser"

const dermoscopyProcessor=(element, melanomaSevenPoint)=>
{
let other_abnormality = ""
let abnormalities = []

let assembledElement= " a skin lesion" 

if (element["Site_of_lesion"] !== "")
    {
    assembledElement += ` on their ${element["Site_of_lesion"]} `
    }

assembledElement += " with features on dermoscopy concerning for a melanoma"

abnormalities.push(...element["Dermoscopy_Features:"])

if (element["Any_Other_Dermoscopy_Features"] !== "")
    {
    other_abnormality = element["Any_Other_Dermoscopy_Features"]
    abnormalities.push(other_abnormality)

    }
let parsedAbnormalies = arrayParser(abnormalities)

if (abnormalities.length>0)
    {
    assembledElement += ` including ${parsedAbnormalies.toLowerCase()}`
    }


if (element["Present_for_several:"] !== "")
{
assembledElement += ` which have been present for several ${(element["Present_for_several:"]).toLowerCase()}`
}


return (assembledElement)
}

export default dermoscopyProcessor